import { Vector2 } from '@technology/web3d-plugin-threejs';
import { LonLat } from './lon-lat.types';
import { Point2D } from '../../geometry/point/point.types';

export const lonLatToVector2 = (lonLat: LonLat): Vector2 =>
  new Vector2(lonLat.lon, lonLat.lat);

export const lonLatToPoint2D = (lonLat: LonLat): Point2D => ({
  x: lonLat.lon,
  y: lonLat.lat,
});

export const point2DToLonLat = (point: Point2D): LonLat => ({
  lon: point.x,
  lat: point.y,
});

/**
 * Converts geographic coordinates (longitude, latitude) to Web Mercator projection coordinates in meters.
 *
 * @param lonLat - The geographic coordinates containing longitude and latitude values in decimal degrees
 * @returns An object containing x and y coordinates in meters
 *
 * @remarks
 * - The x-coordinate represents the distance in meters from the Prime Meridian (0° longitude)
 * - The y-coordinate represents the distance in meters from the Equator (0° latitude)
 * - The latitude value is clamped to avoid infinity values at the poles
 */
export const lonLatToWebMercatorMeters = (lonLat: LonLat): Point2D => {
  const EARTH_RADIUS = 6378137.0;
  const DEGREES_TO_RADIANS_DIVISOR = 180;
  const TAN_DIVISOR = 2;
  const TAN_OFFSET = 4;

  const x =
    ((lonLat.lon * Math.PI) / DEGREES_TO_RADIANS_DIVISOR) * EARTH_RADIUS;

  const latRad = (lonLat.lat * Math.PI) / DEGREES_TO_RADIANS_DIVISOR;
  const y =
    Math.log(Math.tan(latRad / TAN_DIVISOR + Math.PI / TAN_OFFSET)) *
    EARTH_RADIUS;

  return { x, y };
};
